import { Module } from "vuex";

import { RootState } from "../RootState";
import flowLegalPersonFileService from "../../services/InscriptionFlowLegalPersonFileService";
import { FlowFile } from "../../models/responses/FlowFile";

export interface InscriptionFlowFileState {
  flowLegalPersonFiles: any[];
}

export const inscriptionFlowLegalPersonFileModule: Module<
  InscriptionFlowFileState,
  RootState
> = {
  namespaced: true,
  // Données partagées du magasin (ne peuvent pas être modifiées directement)
  state: {
    flowLegalPersonFiles: []
  },

  // Accesseurs pour propriétés calculées
  getters: {},

  // Opérations de modification des données
  mutations: {
    /**
     * Met à jour la liste des inscriptionFlows dans le store.
     * @param {any} state object contenant les valeurs d'états de l'application
     * @param {any} value nouvelle valeur à enregistrer
     */
    setFlowFiles(state, value: FlowFile[]) {
      state.flowLegalPersonFiles = value;
    },
    addFlowFile(state, flowFile: FlowFile) {
      state.flowLegalPersonFiles.push(flowFile);
    },
    deleteFlowFile(state, id: number) {
      const index = state.flowLegalPersonFiles.findIndex(
        file => file.id === id
      );
      if (index !== -1) {
        state.flowLegalPersonFiles.splice(index, 1);
      }
    }
  },

  // Actions pouvant être appelées par les vues pour agir sur le magasin
  actions: {
    /**
     * Demande le chargement des InscriptionFlows via API
     * @param {any} param0
     */
    async listByFlow(context, flowId: number) {
      const response = await flowLegalPersonFileService.listByFlow(flowId);
      context.commit("setFlowFiles", response.data);
      return response.data;
    },

    async deleteFlowFile(context, guid: string) {
      const response = await flowLegalPersonFileService.deleteFlowFile(guid);
      context.commit("deleteFlowFile", response.data.id);
      return response.data;
    },
    async uploadAssociatedFile(
      context,
      payload: { flowId: number; file: File }
    ) {
      const response = await flowLegalPersonFileService.createFlowFile(
        payload.flowId,
        payload.file
      );
      context.commit("addFlowFile", response.data);
      return response.data;
    }
  }
};
